import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import Api from '@app/services/api';

export const useOrderRedirectQuery = (orderUid: string) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: () => Api.orders.getOrder(orderUid),
    onSuccess: (order) => {
      if (order.process?.uid) {
        navigate(`/dashboard/processes/${order.process.uid}/orders/${orderUid}`);
      }
    },
  });
};
